import { render, staticRenderFns } from "./xkgcs.vue?vue&type=template&id=f2bbe12c&scoped=true&"
import script from "./xkgcs.vue?vue&type=script&lang=js&"
export * from "./xkgcs.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/reportEditor/reportEditor.less?vue&type=style&index=0&id=f2bbe12c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bbe12c",
  null
  
)

component.options.__file = "xkgcs.vue"
export default component.exports